import React, { useEffect, useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Button, Form, Input, Alert } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import {
  signIn,
  showLoading,
  showAuthMessage,
  hideAuthMessage,
  authenticated,
} from "store/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const rules = {
  userId: [
    {
      required: true,
      message: "Please enter Username!",
    },
  ],
  password: [
    {
      required: true,
      message: "Please enter password!",
    },
  ],
};

export const LoginForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { result, loading } = useSelector(
    (state) => state.auth
  );

  // const {
  //   hideAuthMessage,
  //   showLoading,
  //   signIn,
  //   token,
  //   loading,
  //   showMessage,
  //   message,
  //   redirect,
  // } = props;

  //const onLogin = (values) => {
  //  console.log("usertes",values)
  const onLogin = (values) => {  
    dispatch(signIn(values));
  };

  useEffect(() => { 
    
  if (result?.userBranchs?.length > 0) {
    navigate("/auth/branch");
  }
}, [result]);

  // useEffect(() => {
  //   console.log("🚀 ~ useEffect ~ token:", token);
  //   console.log("🚀 ~ useEffect ~ mode:", mode);
  //   console.log("🚀 ~ useEffect ~ userBranch:", userBranch);

  //   if (mode == null && token == null) {
  //     console.log("redirect login");
  //     navigate("/auth/login");
  //   } else if (userBranch !== null && mode !== "am") {
  //     console.log("redirect branch");
  //     navigate("/auth/branch");
  //   } else if (mode == "am") {
  //     dispatch(authenticated({ branchId: "-", branchName: "-" }));
  //   }
  //   if (showMessage) {
  //     const timer = setTimeout(() => hideAuthMessage(), 3000);
  //     return () => {
  //       clearTimeout(timer);
  //     };
  //   }
  // }, [showMessage, userBranch, mode]);

  return (
    <>
      {/* <motion.div
        initial={{ opacity: 0, marginBottom: 0 }}
        animate={{
          opacity: showMessage ? 1 : 0,
          marginBottom: showMessage ? 20 : 0,
        }}
      >
        <Alert type="error" showIcon message={message}></Alert>
      </motion.div> */}
      <Form layout="vertical" name="login-form" onFinish={onLogin}>
        <Form.Item name="userId" label="Username" rules={rules.userId}>
          <Input
            placeholder="Enter your Username"
            prefix={<UserOutlined className="text-primary" />}
          />
        </Form.Item>
        <Form.Item
          placeholder="Enter your password"
          name="password"
          label="Password"
          rules={rules.password}
        >
          <Input.Password
            placeholder="Enter your Password"
            prefix={<LockOutlined className="text-primary" />}
          />
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            style={{ width: "50%", marginTop: "10px" }}
            type="primary"
            htmlType="submit"
            block
            loading={loading}
          >
            Login
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

LoginForm.propTypes = {
  extra: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

// const mapStateToProps = ({ auth }) => {
//   const { loading, message, showMessage, token, redirect } = auth;
//   return { loading, message, showMessage, token, redirect };
// };

// const mapDispatchToProps = {
//   signIn,
//   showAuthMessage,
//   showLoading,
//   hideAuthMessage,
// };

// export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
export default LoginForm;
